import React from 'react';
// images
import desktopImageWebp from './images/sustainability-impact-landing-hero-desktop.webp';
import mobileImageWebp from './images/sustainability-impact-landing-hero-mobile.webp';
// low res images
import { lowResImageDesktop, lowResImageMobile } from './lowResImages';
// styles
import { HeroSectionStyled } from './styles';

export default () => (
  <HeroSectionStyled
    sectionId='sustainability-impact-hero'
    productName='Sustainability and Impact'
    headingText='A better way to tomorrow.'
    descriptionText={<>Guided by our mission to improve lives through financial security, we focus on actions today that shape a better way to tomorrow.</>}
    ctaPrimary={{
      linkUrl: '/assets/pdf/sustainability/2024-sustainability-and-impact-report.pdf',
      buttonText: 'Read the report',
      ariaLabel: 'Read the sustainability and social impact report.',
      isInternalPdf: true,
      children: '',
    }}
    backgroundImageAriaLabel='Three women sitting on a patio discussing insurance benefits'
    backgroundImageDesktop={desktopImageWebp.toString()}
    backgroundImageMobile={mobileImageWebp.toString()}
    backgroundImageDesktopLowRes={lowResImageDesktop}
    backgroundImageMobileLowRes={lowResImageMobile}
    moduleName='hero-module'
    moduleVariation='A'
    backgroundVariant='lightB'
    themeType='lightTheme'
  />
);
